import React from "react";
import { DownloadOutlined, HomeOutlined, InboxOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Form, Input, InputNumber, Modal, Select } from "antd";
import "./service_item_master.css";
import { HiOutlineDocumentCheck } from "react-icons/hi2";
import { MdDriveFolderUpload } from "react-icons/md";
import { IoMdAddCircle } from "react-icons/io";
import {
    withServiceItemMasterLogic,
    WithServiceItemMasterLogicProps,
} from "../../../components/hoc_service_item_mastet";
import Dragger from "antd/es/upload/Dragger";

const ServiceItemMaster: React.FC<WithServiceItemMasterLogicProps> = ({
    brands,
    models,
    form,
    warehouseName,
    handleSubmit,
    handleExportTemplate,
    isImportModalOpen,
    handleOpenImportModal,
    handleCloseImportModal,
    uploadProps,
    handleImportSubmit,
    isImporting,
    isEditMode,
    handleReset

}) => {
    const transformStyle = { transform: "scale(0.80)", transformOrigin: "top left", width: "125%" };
    const Submitbtn = HiOutlineDocumentCheck as React.ComponentType<any>;
    const Importbtn = MdDriveFolderUpload as React.ComponentType<any>;
    const Addbtn = IoMdAddCircle as React.ComponentType<any>;

    return (
        <div id="i6ho" style={transformStyle}>
            <div className="gjs-grid-row" id="i74j">
                <div className="gjs-grid-column" id="ige6">
                    <Breadcrumb
                        items={[
                            { title: <HomeOutlined /> },
                            {
                                href: "#/dashboard/data_service_item_master",
                                title: (
                                    <>
                                        <span>Service Item Master</span>
                                    </>
                                ),
                            },
                            { title: "Input Item Master" },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="ixq62">
                <div className="gjs-grid-column" id="ia5n2">
                    <Button className="gr-button" onClick={handleReset}>
                        <Addbtn style={{ width: "1em", height: "1em", marginRight: "8px" }} />
                        New
                    </Button>
                    <Button className="gr-button" onClick={handleSubmit}>
                        <Submitbtn style={{ width: "1em", height: "1em", marginRight: "8px" }} />
                        {isEditMode ? "Update" : "Submit"}
                    </Button>
                    <Button className="gr-button" onClick={handleOpenImportModal}>
                        <Importbtn style={{ width: "1em", height: "1em", marginRight: "8px" }} />
                        Import
                    </Button>
                </div>
            </div>

            <div className="gjs-grid-row" id="iudrf">
                <div className="gjs-grid-column" id="ir1do">
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 430 }}
                        labelCol={{ style: { width: "150px", textAlign: "left" } }}
                        wrapperCol={{ style: { width: "290px" } }}
                        className="custom-info-purchase-request">
                        <Form.Item label="Status" name="status" style={{ marginBottom: "5px" }}>
                            <Select
                                showSearch
                                placeholder=""
                                optionFilterProp="label"
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                options={[
                                    { label: "Active", value: "1" },
                                    { label: "Deactive", value: "2" },
                                ]}
                            />
                        </Form.Item>
                        <Form.Item label="Brand" name="brand" style={{ marginBottom: "5px" }}>
                            <Select
                                showSearch
                                placeholder=""
                                optionFilterProp="label"
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                options={[{ label: "— Empty —-", value: "" }, ...brands]}
                            />
                        </Form.Item>
                        <Form.Item label="Model" name="model" style={{ marginBottom: "5px" }}>
                            <Select
                                showSearch
                                placeholder=""
                                optionFilterProp="label"
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                options={[{ label: "— Empty —-", value: "" }, ...models]}
                            />
                        </Form.Item>
                        <Form.Item label="Item Code" name="item_code" style={{ marginBottom: "5px" }}
                            rules={[{ required: true, message: 'Required' }]}
                        >
                            <Input placeholder="" readOnly={isEditMode} />
                        </Form.Item>
                        <Form.Item label="Item Name" name="item_name" style={{ marginBottom: "5px" }}
                            rules={[{ required: true, message: 'Required' }]}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item label="FRT" name="frt" style={{ marginBottom: "5px", width: "50%" }}
                            rules={[{ required: true, message: 'Required' }]}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item label="Price flat Rate" name="price_flat_rate" style={{ marginBottom: "5px" }}
                            rules={[{ required: true, message: 'Required' }]}
                        >
                            <InputNumber
                                style={{ width: "50%" }}
                                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                parser={(value) => value?.replace(/\./g, "") as unknown as string}
                            />
                        </Form.Item>
                        <Form.Item label="HPP" name="hpp" style={{ marginBottom: "5px" }}>
                            <InputNumber
                                style={{ width: "50%" }}
                                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                parser={(value) => value?.replace(/\./g, "") as unknown as string}
                            />
                        </Form.Item>
                        <Form.Item label="Price" name="price" style={{ marginBottom: "5px" }}
                        >
                            <InputNumber
                                style={{ width: "50%" }}
                                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                parser={(value) => value?.replace(/\./g, "") as unknown as string}
                                readOnly
                            />
                        </Form.Item>
                        <Form.Item label="Warehouse" name="warehouse" style={{ marginBottom: "5px" }}>
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item label="Remark" name="remark" style={{ marginBottom: "5px" }}>
                            <Input.TextArea placeholder="" rows={5} />
                        </Form.Item>
                    </Form>
                </div>
            </div>

            <div className="gjs-grid-row" id="ih6rg">
                <div className="gjs-grid-column" id="imfou"></div>
            </div>
            <Modal
                title="Import Item Master"
                open={isImportModalOpen}
                onCancel={handleCloseImportModal}
                footer={[
                    <Button key="cancel" onClick={handleCloseImportModal}>
                        Cancel
                    </Button>,
                    <Button key="upload" type="primary" onClick={handleImportSubmit} loading={isImporting} >
                        Upload
                    </Button>
                ]}
            >
                <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        type="link"
                        icon={<DownloadOutlined />}
                        onClick={handleExportTemplate}
                    >
                        Download Template
                    </Button>
                </div>

                <Dragger {...uploadProps} style={{ padding: 20 }}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint">
                        Support for a single upload. Strictly prohibited from uploading company data or other banned files.
                    </p>
                </Dragger>
            </Modal>
        </div>
    );
};

export default withServiceItemMasterLogic(ServiceItemMaster);
